"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingSummariesApi = void 0;
exports.bookingSummariesApi = (http, prefix = '/availability') => ({
    getByOwnerId(id) {
        return http.get(`${prefix}/v2/owner/${id}/booking_summary`);
    }
});
//# sourceMappingURL=index.js.map